export default defineAppConfig({
	host: 'https://www.ivanobazeni.hr',
	lang: 'hr',
	baseCompatibility: '1.36.42',
	multilanguage: true,
	auth: {
		dashboard: 'auth_my_webshoporder',
	},
	cache: {
		enabled: process.env.NODE_ENV == 'development' ? false : true,
	},
	facebook: {
		pixel: {
			env: ['production'],
			apiKey: '684696267761920',
			target: 'head',
			gdpr: 'analytics'
		},
	},
	meta: [
		{name: 'apple-mobile-web-app-title', content: 'ivanobazeni.hr'},
		{name: 'google-site-verification', content: 'YDdVrMwqzIiQOvxS8cGKLhIiznFqSKRSUkaekoHUuss'},
	],
	catalog: {
		productsResponseFields: [
			'id',
			'code',
			'url_without_domain',
			'discount_percent',
			'discount_percent_custom',
			'priority_details',
			'main_image_thumbs',
			'main_image_title',
			'main_image_description',
			'title',
			'attributes_special',
			'category_url_without_domain',
			'category_title',
			'short_description',
			'status',
			'price',
			'price_custom',
			'basic_price',
			'basic_price_custom',
			'extra_price_lowest',
			'is_available',
			'available_quantity',
			'shopping_cart_code',
			'quantity',
			'qty'
		],
		listsResponseFields: ['id', 'code', 'search_id', 'title', 'url_without_domain', 'languages_urls', 'breadcrumbs', 'content', 'seo_description', 'seo_h1', 'seo_keywords', 'seo_title'],
		urls: {
			de: {
				item: 'product',
			},
		},
	},
	publish: {
		postsResponseFields: ['id', 'url_without_domain', 'title', 'main_image_upload_path', 'main_image_title', 'main_image_description', 'main_image_thumbs', 'short_description', 'element_size', 'element_place', 'element_foil', 'element_equipment'],
	},	
})